import * as React from 'react';
import AppHistory from '__common/modules/history';
import BackButton from 'app/components/FooterComponent/BackButton';
import Footer from 'app/components/FooterComponent';
import Header from 'app/components/HeaderComponent';
import Loader from '__common/components/LoaderComponent';
import ProjectConfiguration from 'projectDesign/components/projectConfiguration/projectConfigurationComponent';
import ProjectInfoHeaderMiddleBar from 'projectDesign/components/ProjectInfoHeaderMiddleBar';
import { connect } from 'react-redux';
import { loadDefaultModuleAroura } from '__common/components/moduleSelector/moduleSelector';
import { getProductTitle } from '__common/constants/products_titles';
import { SET_PRODUCT_ID, SET_PROJECT_OPTION, UPDATE_OS_PROJECT_CONFIGURATION } from 'projectDesign/components/projectConfiguration/projectConfigurationActions';
import { isNxtHorizon, products } from '__common/constants/products';
import {
  CLEAR_PROJECT_CONFIGURATION,
  RESET_MODULE_SELECTOR,
  SET_PRODUCT_TITLE,
  CLEAR_ROOFS_SELECTOR,
  IMPORT_OS_FULL_DESIGN_PROJECT,
  SET_ROW_SPACING,
  SET_COLUMN_SPACING,
  CLEAR_OS_BACKGROUND_VISIBLE,
} from 'actions';
import { roofsSelectorState } from '__editor/components/roofsSelector/roofsSelectorReducer';
import { setProductSettings } from '__editor/panelsEditor/components/productsSettings/productsSettings';
import { parseDataForOsImport } from 'osImport/parseDataForOsImport';
import NxtHorizon from 'projectDesign/components/projectConfiguration/utils/defaultProps/NxtHorizon';
import SM from 'projectDesign/components/projectConfiguration/utils/defaultProps/sm';
import { inchesToMeters } from '__common/calculations/inchesToMeters';



type Props = {
  dispatch: Function;
  match: any;
  location?: any;
  moduleSelector: moduleSelectorState;
  projectConfiguration: projectConfigurationState,
  roofsSelector: roofsSelectorState,
  osDesignConfig: osDesignConfigState
};


export class OsDesignConfig extends React.Component<Props, {}> {

  UNSAFE_componentWillMount() {
  }

  componentDidMount() {
    const { dispatch } = this.props;
    const { projectConfiguration } = this.props;
    
    
    if (projectConfiguration.productId) {
      // console.log('🚀 productId is available, setting up configuration...');
      dispatch(SET_PRODUCT_TITLE(getProductTitle(25)));
      setProductSettings(25, 'white', false);
      
      // Get payload data if available
      const payload = this.props.location?.state?.payload;
      
      if (isNxtHorizon(projectConfiguration.productId)) {
        // Merge payload values with NxtHorizon defaults
        const defaultConfig = NxtHorizon();
        
        const mergedConfig = {
          ...defaultConfig,
          ...(payload?.engineering?.windSpeed && { wind_speed: payload.engineering.windSpeed }),
          // Ensure clamps have defaults for OS flow
          end_clamps_choices: defaultConfig.end_clamps_choices || 4,
          mid_clamps_choices: defaultConfig.mid_clamps_choices || 4,
        };
        dispatch(UPDATE_OS_PROJECT_CONFIGURATION(mergedConfig));
      } else {
        // Merge payload values with SM defaults
        const defaultConfig = SM();
        
        const mergedConfig = {
          ...defaultConfig,
          ...(payload?.engineering?.windSpeed && { wind_speed: payload.engineering.windSpeed }),
          // Ensure clamps have defaults for OS flow
          end_clamps_choices: defaultConfig.end_clamps_choices || 1,
          mid_clamps_choices: defaultConfig.mid_clamps_choices || 1,
        };
        dispatch(UPDATE_OS_PROJECT_CONFIGURATION(mergedConfig));
      }
      
      loadDefaultModuleAroura(getKeyByValue(products, projectConfiguration.productId));
    } else {
      console.log(' productId is NOT available in componentDidMount');
    }
  }

  componentDidUpdate(prevProps: Props) {
    const { dispatch, projectConfiguration: { productId: prevProductId } } = prevProps;
    const { projectConfiguration, osDesignConfig: { successfullyImportedProjectId } } = this.props;
    const prevSuccessfullyImportedProjectId = prevProps.osDesignConfig.successfullyImportedProjectId;
    
    // Check if successfullyImportedProjectId changed and has a value
    if (successfullyImportedProjectId && successfullyImportedProjectId.length && 
        successfullyImportedProjectId !== prevSuccessfullyImportedProjectId) {
      this.redirectToDesign(successfullyImportedProjectId);
    }
    
    // Only update configuration when productId actually changes
    if (projectConfiguration.productId && projectConfiguration.productId !== prevProductId) {
      dispatch(SET_PRODUCT_TITLE(getProductTitle(projectConfiguration.productId)));
      setProductSettings(projectConfiguration.productId, 'white', false);
      dispatch(SET_PROJECT_OPTION('os_racking_type', projectConfiguration.productId));
      dispatch(SET_PROJECT_OPTION('mid_clamps_choices', projectConfiguration.productId));
      dispatch(SET_PROJECT_OPTION('os_racking_type',  projectConfiguration.productId));
      
      
      // Get payload data if available
      const payload = this.props.location?.state?.payload;
      
      if (isNxtHorizon(projectConfiguration.productId)) {
        // Merge payload values with NxtHorizon defaults
        const defaultConfig = NxtHorizon();
        const mergedConfig = {
          ...projectConfiguration.projectEnvConfig,
          ...defaultConfig,
          ...(payload?.engineering?.windSpeed && { wind_speed: payload.engineering.windSpeed }),
          // Ensure clamps have defaults for OS flow
          end_clamps_choices: defaultConfig.end_clamps_choices || 4,
          mid_clamps_choices: defaultConfig.mid_clamps_choices || 4,
        };
        dispatch(UPDATE_OS_PROJECT_CONFIGURATION(mergedConfig));
      } else {
        // Merge payload values with SM defaults
        const defaultConfig = SM();
        const mergedConfig = {
          ...projectConfiguration.projectEnvConfig,
          ...defaultConfig,
          ...(payload?.engineering?.windSpeed && { wind_speed: payload.engineering.windSpeed }),
          // Ensure clamps have defaults for OS flow
          end_clamps_choices: defaultConfig.end_clamps_choices || 1,
          mid_clamps_choices: defaultConfig.mid_clamps_choices || 1,
        };
        dispatch(UPDATE_OS_PROJECT_CONFIGURATION(mergedConfig));
      }
      
      loadDefaultModuleAroura(getKeyByValue(products, projectConfiguration.productId));
    }
  }

  componentWillUnmount() {
    const { dispatch } = this.props;
    dispatch(CLEAR_PROJECT_CONFIGURATION());
    dispatch(RESET_MODULE_SELECTOR());
    dispatch(CLEAR_ROOFS_SELECTOR());
  }

  updateInitData = (field, value) => {
    const { dispatch } = this.props;
    dispatch(SET_PROJECT_OPTION(field, value));
    if (field === 'os_racking_type') {
        dispatch(SET_PRODUCT_ID(value))
      }
    if (field === 'mid_clamps_choices') {
      if (value === 1) {
        dispatch(SET_ROW_SPACING(inchesToMeters(1)));
        dispatch(SET_COLUMN_SPACING(inchesToMeters(1)));
      } else if (value === 2) {
        dispatch(SET_ROW_SPACING(inchesToMeters(0.25)));
        dispatch(SET_COLUMN_SPACING(inchesToMeters(0.25)));
      } else if (value === 3) {
        dispatch(SET_ROW_SPACING(inchesToMeters(0.5)));
        dispatch(SET_COLUMN_SPACING(inchesToMeters(0.5)));
      } else {
        dispatch(SET_ROW_SPACING(inchesToMeters(0.5)));
        dispatch(SET_COLUMN_SPACING(inchesToMeters(0.5)));
      }
    }
  }

  renderImage = (image)=>{
    const img = new Image();
    img.src = image;
    img.onload = () => {
        const element = document.querySelector<HTMLElement>(".os-image");
        if (element) {
            element.style.background = `url('${image}') no-repeat`;
        }
    };
  }

  submitForm = () => {
    const {
      dispatch,
      projectConfiguration: { projectEnvConfig },
      projectConfiguration: { productId },
      moduleSelector,
    } = this.props;

    dispatch(CLEAR_OS_BACKGROUND_VISIBLE());
    const payload = this.props.location?.state?.payload;
    if (!payload) {
      console.error('OpenSolar project payload is missing from the route state');
      return;
    }
    const data = parseDataForOsImport(
      productId,
      projectEnvConfig,
      moduleSelector.modelData,
      payload
    );
    
    dispatch(IMPORT_OS_FULL_DESIGN_PROJECT(data))
  }



  redirectToDesign(projectId) {
    const{ projectConfiguration : {productId }} = this.props
    const { location } = this.props;
    const authToken = location.state?.payload?.authToken;
    
    if (authToken) {
      AppHistory.push({
        pathname: `/project/design/${getKeyByValue(products, productId)}/${projectId}`,
        state: { authToken: authToken }
      });
    } else {
      AppHistory.push(`/project/design/${getKeyByValue(products, productId)}/${projectId}`);
    }
    return null;
  }

  renderLoader() {
    return <Loader />;
  }

  renderFooter = () => {
    const {
      dispatch,
      match: {
        params: { projectId },
      },
    } = this.props;

    return (
      <div className="footer-buttons">
        <BackButton
          url={`/hs/project/${projectId}`}
          dispatch={dispatch}
        />
      </div>
    );
  }

  renderConfigurator() {
    const { projectEnvConfig } = this.props.projectConfiguration;
    const {
      match: {
        params: { productId, projectId },
      },
    } = this.props;
    
    
    return (
      <div className="app-content">
        <Header navigation={true} Infobar={<ProjectInfoHeaderMiddleBar projectId={projectId} />} productId={productId} projectId={projectId} />
        <div className="aurora-design-config">
        <div
            className="aurora-image"
            style={{
              background: `url(${
                projectEnvConfig['aroura_design_screenshot']
              }) no-repeat`,
            }}
        />
          <ProjectConfiguration
            productId={productId}
            initData={projectEnvConfig}
            onChange={this.updateInitData}
            isOs={true}
            onSave={this.submitForm}
          />
          <Footer />
        </div>
      </div>
    );
  }

  render() {
    const {
      projectConfiguration: { projectEnvConfig },
      match: {
        params: { productId, projectId },
      },
    } = this.props;

    if (Object.keys(projectEnvConfig).length) {
      return this.renderConfigurator();
    }
    return (
      <div className="app-content helioscope-design-config">
        <Header navigation={true} Infobar={<ProjectInfoHeaderMiddleBar projectId={projectId} />} productId={productId} projectId={projectId} />
        {this.renderLoader()}
        <Footer />
      </div>
    );
  }
}

function getKeyByValue(object, value) {
  return Object.keys(object).find(key => object[key] === value);
}

function mapStateToProps(state: appState) {
  return {
    projectConfiguration: state.projectConfiguration,
    moduleSelector: state.moduleSelector,
    roofsSelector: state.roofsSelector,
    osDesignConfig: state.osDesignConfig
  };
}

export default connect(mapStateToProps)(OsDesignConfig);
